export default class QDEvaluationIdentityResult {
  HasQuestions: boolean;

  TransactionID: string;
}
